module.exports = __webpack_public_path__ + "media/images/Michal-Brabec_portret_web-d460eb93.jpg";